'use strict';

var index = require('../define-properties/index.js');
var index$1 = require('../function-bind/index.js');
var implementation$1 = require('./implementation.js');
var polyfill$1 = require('./polyfill.js');
var shim$1 = require('./shim.js');

var define = index;
var bind = index$1;

var implementation = implementation$1;
var getPolyfill = polyfill$1;
var polyfill = getPolyfill();
var shim = shim$1;

var boundFlat = bind.call(Function.call, polyfill);

define(boundFlat, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

var array_prototype_flat = boundFlat;

module.exports = array_prototype_flat;
